import Vue from 'vue'

const bizRiskKindCode = {
  glass: '11',
  fixMakeUp: '52'
}

Vue.prototype.$enum = {
  bizRiskKindCode
}
